export default "__VITE_ASSET__C5o20ISX__"